(() => {
  'use strict';
  const body = document.body;
  const isEn = document.documentElement.lang.startsWith('en');
  // Hide the fixed buy button while another fixed interface needs the same space.
  const cookie = document.querySelector('[data-cookie-banner]');
  const cart = document.querySelector('[data-db-cart-drawer]');
  const menu = document.querySelector('[data-mobile-drawer]');
  const syncOverlay = () => body.classList.toggle('db-ui-overlay', Boolean(
    (cookie && !cookie.hidden) || cart?.classList.contains('is-open') || menu?.classList.contains('is-open')
  ));
  const observer = new MutationObserver(syncOverlay);
  [cookie, cart, menu].filter(Boolean).forEach(node => observer.observe(node, { attributes: true, attributeFilter: ['hidden', 'class'] }));
  syncOverlay();
  if (body.dataset.halloween !== 'true') return;
  try { if (localStorage.getItem('dailybear-effects-paused') === 'true') body.classList.add('db-effects-paused'); } catch (_) { /* Optional preference. */ }
  const initToggle = () => {
    document.querySelectorAll('[data-effects-toggle]').forEach(button => {
      if (button.dataset.ready) return;
      button.dataset.ready = 'true';
      const sync = () => {
        const paused = body.classList.contains('db-effects-paused');
        button.setAttribute('aria-pressed', String(paused));
        button.querySelector('span').textContent = paused ? (isEn ? 'Resume effects' : 'Effecten hervatten') : (isEn ? 'Pause effects' : 'Effecten pauzeren');
      };
      button.addEventListener('click', () => {
        body.classList.toggle('db-effects-paused');
        try { localStorage.setItem('dailybear-effects-paused', String(body.classList.contains('db-effects-paused'))); } catch (_) { /* Optional preference. */ }
        sync();
      });
      sync();
    });
  };
  initToggle();
  document.addEventListener('shopify:section:load', initToggle);
})();


/* Place mobile evidence immediately below the photo, with reviews below buying. */
(function () {
  'use strict';
  var style = document.createElement('style');
  style.id = 'dailybear-mobile-inline-proof';
  style.textContent = `
    .db-mobile-inline-proof{display:none}
    @media(max-width:749px){
      .db-mobile-product .db-product-shortcuts{display:none!important}
      .db-mobile-product .db-mobile-inline-proof{display:grid!important;grid-template-columns:minmax(0,1fr)!important;gap:0!important;margin:10px 0 0!important;width:100%!important;min-width:0!important}
      .db-mobile-product>.db-mobile-proof-grid:empty{display:none!important}
      .db-mobile-product .db-mobile-inline-proof>section{padding:10px!important;border-radius:13px!important}
      .db-mobile-product .db-mobile-inline-science .db-mobile-heading{font-size:15px!important;margin-bottom:7px!important}
      .db-mobile-product .db-mobile-inline-science .db-evidence__stats{gap:6px!important}
      .db-mobile-product .db-mobile-inline-science .db-evidence__stats article{padding:8px!important;border-radius:9px!important}
      .db-mobile-product .db-mobile-inline-science .db-evidence__number{font-size:27px!important}
      .db-mobile-product .db-mobile-inline-science .db-evidence__stats h3{font-size:11px!important;line-height:1.35!important;margin:3px 0!important}
      .db-mobile-product .db-mobile-inline-science p.db-mobile-comparison{font-size:11px!important;margin:3px 0!important}
      .db-mobile-product .db-mobile-inline-science summary{font-size:11px!important;min-height:30px!important}
      .db-mobile-product .db-mobile-inline-science .db-mobile-study-note{font-size:11px!important;line-height:1.45!important;margin-top:7px!important}
      .db-mobile-product .db-mobile-inline-reviews .db-reviews__summary{gap:5px!important}
    }`;
  document.head.appendChild(style);
  function start() {
    var root = document.querySelector('[data-product-root]');
    if (!root) return;
    var media = window.matchMedia('(max-width:749px)');
    function place() {
      if (!media.matches || !root.classList.contains('db-mobile-product')) return;
      var gallery = root.querySelector('.product-gallery');
      var info = root.querySelector('.product-info');
      var science = document.getElementById('CreatineResearch');
      var reviews = document.getElementById('ProductReviews');
      if (gallery && science) {
        var left = gallery.querySelector('.db-mobile-inline-science');
        if (!left) {
          left = document.createElement('div');
          left.className = 'db-mobile-proof-grid db-mobile-inline-proof db-mobile-inline-science';
          gallery.appendChild(left);
        }
        left.appendChild(science);
      }
      if (info && reviews) {
        var right = info.querySelector('.db-mobile-inline-reviews');
        if (!right) {
          right = document.createElement('div');
          right.className = 'db-mobile-proof-grid db-mobile-inline-proof db-mobile-inline-reviews';
          info.appendChild(right);
        }
        right.appendChild(reviews);
      }
    }
    // The base mobile layout owns the desktop restoration markers for both nodes.
    // Wait until its responsive update has completed before moving the live nodes.
    media.addEventListener('change', function () { window.setTimeout(place, 0); });
    place();
  }
  if (document.readyState === 'complete') start();
  else document.addEventListener('DOMContentLoaded', start, {once:true});
})();

/* Daily Bear: price per daily serving (150 gummies / 5 = 30 servings). */
(function () {
  'use strict';
  function start() {
    var price = document.querySelector('.product-main-price');
    if (!price || document.querySelector('.db-daily-price')) return;
    var note = document.createElement('div');
    note.className = 'db-daily-price';
    note.setAttribute('aria-live', 'polite');
    note.style.cssText = 'display:flex;flex-direction:column;gap:3px;margin:8px 0 18px;padding:10px 14px;border-left:3px solid #315449;border-radius:0 8px 8px 0;background:#edf5ef;color:#203f33;line-height:1.4;';
    var headline = document.createElement('strong');
    headline.style.cssText = 'font-size:17px;font-weight:750;';
    var detail = document.createElement('span');
    detail.style.cssText = 'font-size:12px;color:#43594d;';
    note.appendChild(headline);
    note.appendChild(detail);
    price.insertAdjacentElement('afterend', note);
    function update() {
      var current = price.querySelector('[data-price-current]');
      var raw = current ? current.textContent : '';
      if (raw.indexOf('€') === -1) { note.hidden = true; return; }
      var numeric = raw.replace(/[^0-9.,]/g, '');
      if (numeric.indexOf(',') !== -1) numeric = numeric.replace(/\./g, '').replace(',', '.');
      var amount = Number(numeric);
      if (!(amount > 0)) { note.hidden = true; return; }
      note.hidden = false;
      var lang = document.documentElement.lang.slice(0, 2);
      var copy = {
        nl: ['Slechts ', ' per dag', '30 dagdoseringen per zak · 5 gummies per dag'],
        en: ['Only ', ' per day', '30 daily servings per pouch · 5 gummies per day'],
        fr: ['Seulement ', ' par jour', '30 portions par sachet · 5 gummies par jour'],
        de: ['Nur ', ' pro Tag', '30 Tagesportionen pro Beutel · 5 Gummies pro Tag']
      }[lang] || ['Only ', ' per day', '30 daily servings per pouch · 5 gummies per day'];
      var daily = new Intl.NumberFormat(lang === 'en' ? 'en-IE' : lang, {style:'currency', currency:'EUR'}).format(Math.round(amount * 100 / 30) / 100);
      headline.textContent = copy[0] + daily + copy[1];
      detail.textContent = copy[2];
    }
    update();
    new MutationObserver(update).observe(price, {childList:true, subtree:true, characterData:true});
    new MutationObserver(update).observe(document.documentElement, {attributes:true, attributeFilter:['lang']});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
})();
